/* Crews de GET /rpg/crews: ja vem ordenadas por XP somado dos membros,
   mas a ordem da tela nao pode depender disso. */

const posicao_ou_fim = (posicao) => (typeof posicao === "number" ? posicao : Number.MAX_SAFE_INTEGER);

export function ordenar_crews(Crews) {
  if (!Array.isArray(Crews)) return [];
  return Crews
    .filter(Boolean)
    .sort((a, b) => (Number(b?.xpTotal) || 0) - (Number(a?.xpTotal) || 0) || posicao_ou_fim(a?.posicao) - posicao_ou_fim(b?.posicao));
}

export function get_three_crew_top_rankings(Crews) {
  return ordenar_crews(Crews).slice(0, 3);
}

export function get_crew_by_slug(crew_slug, Crews) {
  if (!crew_slug || !Array.isArray(Crews)) return undefined;
  const alvo = String(crew_slug).toLowerCase();
  return Crews.find((crew) => crew?.slug?.toLowerCase() === alvo);
}

export function get_total_members_crew(Crews) {
  if (!Array.isArray(Crews)) return 0;
  return Crews.reduce((total, crew) => total + (crew?.membros?.length || 0), 0);
}

export function get_total_xp_crews(Crews) {
  if (!Array.isArray(Crews)) return 0;
  return Crews.reduce((total, crew) => total + (Number(crew?.xpTotal) || 0), 0);
}

// referencia da barra de progresso: a crew com mais XP
export function get_maior_xp_crew(Crews) {
  if (!Array.isArray(Crews)) return 0;
  return Crews.reduce((maior, crew) => Math.max(maior, Number(crew?.xpTotal) || 0), 0);
}

export function get_nivel_medio_crew(membros) {
  if (!Array.isArray(membros) || !membros.length) return 0;
  const soma = membros.reduce((total, membro) => total + (Number(membro?.nivel) || 0), 0);
  return Math.round(soma / membros.length);
}
